export function maskUsername(phone, zoneCodeLength){

    if(!phone) {
        return '';
    }
    if(phone.length <= 3){
        return phone;
    }
    const zone = phone.substring(0, zoneCodeLength);
    const number = phone.substring(zoneCodeLength);

    if(number <= 6) {
        return number;
    }

    const n_length = number.length;
    const mask_show_length = 3 ;
    const mask_code_length = 3 ;

    const part1 = number.substring(0, n_length - (mask_show_length + mask_code_length ));
    const part2 = "***" ;
    const part3 = number.substring(n_length -3, n_length)
    return zone + ' ' + part1 + part2 + part3;
}
